import { clone, state, ui, res, prefs } from './stores.js';
import { frameFor } from './frames.js';
import { get } from 'svelte/store';
import { get as idbGet, set as idbSet, getMany as idbGetMany, setMany as idbSetMany } from 'idb-keyval';
import firebase from 'firebase/app';
//import { RealtimeDatabase } from './rtdb.js';
import { dbUpdateGame, getCompressedState, getDecompressedState, reactToDB, setCaptainUsername, setLastState, subToUpdates, updateGame } from './sb.js';
import { decodePayload } from './wire.js';
//import "firebase/firestore";
import "firebase/auth";
import { choose, chooseCards, pause, changeSeat, changeView, info, skipToEndOfTurn, pushChoice, debounce } from './ui.js';
import { doAction, getPlayerIndex, getCard, updateState, prng } from './game.js';
import { resolveAction } from './parse.js';
import { takeTurns, until } from './turns.js';
import * as jsonpatch from 'fast-json-patch';
import { addDBItem, adminLogin, closeMessage, currentMessage, getGame, pastMessages, pb, PBLogin, sendMessage, subscribeTable, unsubscribeTable, updateItem } from './anydb.js';
import { tick } from 'svelte';
import { sha256 } from "crypto-hash";
import { resetContinuationBaseline } from './continuation.js';
import { PB_WRITE, statsSource } from './migration_flags.js';
import { createStatsStore } from './stcc_pb.js';

// Finished games, campaigns and usernames on PocketBase. See docs/pocketbase-migration-plan.md.
const pbStats = createStatsStore(pb, {get: idbGet, set: idbSet, getMany: idbGetMany, setMany: idbSetMany});
export const ensureGameDetails = (games) => pbStats.ensureDetails(games);

async function pbWriteReady(){
    // The upload routes accept any logged-in account; anydb.js normally has one already.
    if(!pb.authStore || !pb.authStore.isValid) await adminLogin();
}

let fireBaseInitialised = false;
let uid;
let username;
let usernames;
let uidURL;
let db;

export function getID(){
    return id;
}

export function numMultiPlayers(){
    let s = get(ui).seats;
    //console.log(s);
    return Array.from(new Set(get(state).players.map(p => p.username))).length;
}

export async function changePlayer(p){
    
    if(typeof p === 'object'){
        p = get(state).players.findIndex(pl => pl.captain == p.captain);
    }
    if(get(state).activePlayer == p){
        console.log('No need to change player: still '+p);
    }else{
        console.log('changing player', p)
        // First check who has what roles/seats
        state.update(s => {
            s.activePlayer = p; // TODO really??
            return s;
        })
    }
    
    // THis is what needs sorting!
    if(isMe(p)){
        // then if not: changeSeat(p);
        changeSeat(p);
    }else{
        changeView(p);
    }
    
}

class RTDBConnection{
    funcs;
    sendingConnection;
    receivingConnection;
    peer;
    id;
    messageNum;

    constructor(peer, conn){
        this.peer = peer;
        this.id = conn.id;
        this.funcs = {};
        this.receivingConnection = conn;
        this.messageNum = 0;
        console.log('Calling open within connection constructor');
        this.call('open');
        /*this.peer.db.connect(id).then((c) => {
            this.receivingConnection = c;
            
        })*/
        
    }

    addSendingConnection(c){
        this.sendingConnection = c;
        console.log('Calling open within connection '+this.id+' addSendingConnection');
        if(this.peer.host){
            console.log('Sending acknowledgement', this.sendingConnection.id)
            this.sendingConnection.send({connectionOpen: true}); // an acknowledgement
            //this.call('open', this);
        }
        
    }

    on(type, func){
        console.log('Connection '+this.id+': adding on for '+type);
        this.funcs[type] = func;
    }

    call(type, info = null){
        console.log('Connection '+this.id+': Responding to call '+type, this.funcs[type]);
        if(this.funcs[type]) this.funcs[type](info);
    }

    send(data){
        if(!this.sendingConnection) throw new Error('No sending connection!')
        this.messageNum++;
        console.log('sending', this.messageNum, data);
        this.sendingConnection.send(data);
    }

    close(){
        
    }
}

class RTDBPeer{
    id;
    funcs;
    db;
    myConnectionID;
    disposeConn;
    host;
    connection;

    constructor(id = false){
        this.funcs = {};
        this.db = new RealtimeDatabase();
        this.db.createConnection().then((c) => {
            this.id = c.id;
            this.host = false;
            this.connection = new RTDBConnection(this, c);
            if(this.disposeConn) this.disposeConn();
            this.disposeConn = c.subscribe((s) => {
                console.log('RTDB calling: data received', s)
                if(s.peerConnection){
                    this.host = true;
                    this.connect(s.peerConnection, false);
                    console.log('Calling connection within Peer');
                    this.call('connection', this.connection);
                    /*this.db.connect(s.peerConnection).then((_c) => {
                        this.connections.push(_c);
                        //
                    })*/
                }else if(s.connectionOpen){
                    console.log('Connection open');
                    if(this.host){
                        console.log('Eek! I am host so should not be getting connection open events')
                    }else{
                        this.connection.call('open', null);
                    }
                }else{
                    console.log('Calling data within Peer', s);
                    this.connection.call('data', s);
                    /*for(let c of this.connections){
                        c.call('data', s);
                    }*/
                    //this.call('data', s);
                }
            });
            //console.log('Calling open for Peer');
            this.call('open', this.id);
        });
    }

    on(type, func){
       console.log('Connection: adding on for '+type);
       this.funcs[type] = func;
    }

    call(type, info){
        console.log('Peer: Responding to call '+type, this.funcs[type]);
        if(this.funcs[type]) this.funcs[type](info);
    }

    connect(id, sendBack = true){
       // let conn = new RTDBConnection(this, id);
        //this.connections.push(conn);
        /*this.db.connect(id).then((c) => {
            this.connections.push(c);
            this.call('')
        })*/
       this.db.connect(id).then((c) => {  
            //let sc = this.connection.sendingConnection;  
            this.connection.addSendingConnection(c);
            if(sendBack){ // New connection
                console.log('calling in Peer: sending connection request', id, this.id)
                this.host = false;
                c.send({peerConnection: this.id});
            }
        });
        return this.connection;
        //return this.connections.length;
    }
    
    destroy(){
        // Nothing for now
    }
}

const JOIN_STEP_TIMEOUT_MS = 60 * 1000;

export async function requestToJoin(id, captain){
    try{
        const record = await pb.collection('stcc_requests').create({
            nanoid: id,
            requesting_username: get(prefs).username,
            requesting_captain: captain,
            status: 'requested'
        });
        // Below is not agnostic, but hey, in for a penny
        pb.collection('stcc_requests').subscribe(record.id, (e) => {
            console.log('[req] joining requests update', e);
            if(e.action == 'update' && e.record.status == 'accepted'){
                // The host clears this too, so it may already be gone.
                pb.collection('stcc_requests').delete(record.id).catch(() => {});
                /*if(confirm(`Your request to join game as ${captain} has been accepted. Join now?`)){
                    joinGame(id, captain);
                }*/
               ui.update(ui => {
                ui.requestGranted = {id, captain};
                return ui;
               })  
            }else if(e.action == 'delete'){
                pb.collection('stcc_requests').unsubscribe(record.id); // not `id`, which is the game's nanoid
            }
        })
        return true;
    }catch(e){
        console.log('Unable to make request: '+e.message);
    }
}

export async function confirmRequest(r){
    let choice = await choose(`${r.requesting_username} is asking to join the game as ${r.requesting_captain}. Allow?`, ['Yes', 'No'], {noChoiceLogging: true});
    if(choice == 'Yes'){
        await pb.collection('stcc_requests').update(r.id, {status: 'accepted'}); // maybe not necessary?
        // add to game 
        let i = get(state).players.findIndex(p => p.captain == r.requesting_captain);
        if(i == -1){
            alert(`Could not find ${r.requesting_captain} in this game.`);
            await pb.collection('stcc_requests').delete(r.id);
            return false;
        }
        await setCaptainUsername(get(state).dbID, i+1, r.requesting_username);
        // The requester deletes this when it sees the acceptance, but if they are
        // offline it would otherwise sit on the lobby as "requested by" forever.
        try{
            await pb.collection('stcc_requests').delete(r.id);
        }catch(e){
            console.log('Request already cleared', e.message);
        }
        return true;
    }else{
        await pb.collection('stcc_requests').delete(r.id);
    }
}

export async function listenToRequests(id){
    try{
        let requests = await pb.collection('stcc_requests').getFullList({filter: `nanoid="${id}"`});
        for(let r of requests){
            await confirmRequest(r); // deal with every pending request, not just the first
        }
        unsubscribeTable('stcc_requests');
        // Keep listening: a game has more than one seat, a player can be replaced,
        // and dropping the subscription after the first acceptance meant the host
        // simply stopped hearing about anyone else.
        subscribeTable('stcc_requests', async (e) => {
            console.log('[req] listening requests update', e);
            if(e.record.nanoid != id) return;
            if(e.action == 'create') await confirmRequest(e.record);
        });
    }catch(e){
        alert('Unable to subscribe to game updates (online will not function):'+e.message);
    }
}

export async function joinGame(g, asCaptain) {
    // Always fetch the row ourselves. The lobby list is projected down to the
    // metadata the table needs, so a record handed in from there has no state on
    // it — and re-reading is what we want anyway, since the listed copy may be
    // several moves out of date by the time someone clicks Enter.
    let id = typeof g == 'string' ? g : g.nanoid;
    try{
        g = await getGame('current_games', id);
        unsubscribeTable('stcc_requests'); // So we are not bothered by them anymore
    }catch(e){
        alert('Unable to join game: '+e.message);
        return; // this used to fall through and fail again, less helpfully
    }
    if(!g || !g.state_compressed){
        alert('That game has no saved state on the server, so it cannot be joined.');
        return;
    }

    let decomp;
    try{
        decomp = decodePayload(g.state_compressed);
    }catch(e){
        alert('That game\'s saved state could not be read: '+e.message);
        return;
    }

    if(asCaptain){
        let i = decomp.players.findIndex(p => p.captain == asCaptain);
        if(i == -1){
            alert(`${asCaptain} is not in that game.`);
            return;
        }

        if(decomp.players[i].username == g.host){ // To stop lots of people taking over
            await setCaptainUsername(g.id, i+1, get(prefs).username);
            g['captain'+(i+1)+'_username'] = get(prefs).username;
        }else if(decomp.players[i].username != get(prefs).username){
            alert(`Player already taken! Exiting`);
            return;
        }

    }
    state.update(s => {
        s = decomp;
        s.dbID = g.id;
        s.players[0].username = g.captain1_username || s.players[0].username; // In case of change
        s.players[1].username = g.captain2_username || s.players[1].username; // In case of change
        return s;
    }) 
    res.update(r => {
        r = {...get(res), ...(g.res_compressed ? getDecompressedState(g.res_compressed) : {})}; // !! TODO revert later
        return r;
    });

    ui.update(ui => {
        if(!asCaptain) ui.observer = true;
        if(get(state).players.every(p => p.started)) ui.gettingToStep = true;
        return ui;
    })
    
    setLastState(get(state));

    
    /*if($state.players[$state.activePlayer].username == $prefs.username)*/ // to stop active player relogging everything

    takeTurns();

    // Bounded: an untimed wait here is what makes a bad rejoin hang instead of fail.
    let arrived = await until(_ => !get(ui).gettingToStep, JOIN_STEP_TIMEOUT_MS);
    if(!arrived){
        console.log('Timed out getting to the current step: continuing anyway');
        ui.update(u => {
            u.gettingToStep = false;
            return u;
        })
    }

    ui.update(ui => {
        ui.tab = 'game';
        return ui;
    });
    //$ui.synced = true;
    
    

    
    // State could have changed by this point, so reload
    try{
        g = await getGame('current_games', id);
    }catch(e){
        g = false;
    }
    if(!g){
        // It's been deleted!
        alert("Game was removed unexpectedly!");
        return;
    }
    if(get(state).dbID != g.id){
            state.update(s => {
            s.dbID = g.id;
            return s;
        })
    }
    await reactToDB({
        new: g,
        old: {}
    }, true, true); 
    await tick();
    
    if(g.host == get(prefs).username) await listenToRequests(get(state).gameID);
    let listening = await subToUpdates(get(state).gameID);
    if(!listening){
        alert('Joined, but could not subscribe to updates: this game will not stay in sync. Use Pull state from server in the Network pane, or reopen the game to retry.');
    }
    // NB there is still a window between reading the row above and the subscription
    // going live. Closing it properly means subscribing first and buffering, which
    // is a change to the shape of this function rather than a patch to it.
    
    
    // To bring things up to date
    /*if($state.players[$state.activePlayer].username == $prefs.username){
        // Current player
        $ui.loadedChoices = g.changelist;
        await catchupFully();
    }else{
        // Just apply diffs
        if(g.changediffs_compressed){
            let patch = getDecompressedState(g.changediffs_compressed).patch;
            jsonpatch.applyPatch($state, patch);
        }
    }*/
    
}

export function iAmHost(){
    if(get(ui).peerID && get(state).hostPeer == get(ui).peerID) return true;
    return false;
}

export function isMe(p, evenInDBMulti = true){
    if(!evenInDBMulti) return true; // !!! TODO multi take it out potentially
    if(get(ui).observer) return false; // !! TODO allow to remove...
    if(typeof p === 'number'){
        p = get(state).players[p];//get(state).players.findIndex(pl => pl.captain == p.captain);
    }
    if(!p) return false;
    if(!p.username) return false;// throw 'invalid player!';
    // Check seats
    //if(p == -1) throw 'invalid player!';
    /*if(!get(ui).seats[p]){
        console.log('Error: no seats', get(ui), p);
        return true; // One player
    }
    if(get(ui).seats[p].id == get(ui).peerID) return true;*/
    if(p.username == get(prefs).username) return true;
    return false;
}

/*export function network(){
    state.subscribe(s => {
        if(isMe(s.activePlayer)){
            // send update over network. Only the active player can do this!
        }
        
    })
}*/

let authorisedUIDs = {
    'TGE5hwzpNvYSU4JT6eXYDgPOQIF3':'hutchies'
};

export function isAuthorised(){
    if(authorisedUIDs[uid]) return authorisedUIDs[uid];
    return false;
}

export function getUID(){
    return uid;
}

async function getCachedUsername(){
    if(get(prefs).username){
        username = get(prefs).username;
        return username;
    }
    let localUsername = await idbGet('username');
    if(localUsername){
        username = localUsername;
        prefs.update(p => {
            p.username = username;
            return p;
        });
        return username;
    }
    return false;
}

export async function getUsername(){
    if(!window.navigator.onLine){
        let cachedUsername = await getCachedUsername();
        if(cachedUsername) return cachedUsername;
        return await setUsername();
    }

    let firebaseReady = await initialiseFirebase();
    if(firebaseReady && username){
        try{
            await PBLogin(username);
        }catch(error){
            console.log('Unable to log username into PocketBase: '+error.message);
        }
        return username;
    }

    if(firebaseReady && !username) username = await setUsername();
    if(!firebaseReady){
        let cachedUsername = await getCachedUsername();
        if(cachedUsername) return cachedUsername;
        username = await setUsername();
    }

    if(firebaseReady && username){
        try{
            await PBLogin(username);
        }catch(error){
            console.log('Unable to log username into PocketBase: '+error.message);
        }
    }

    return username;
}

export function handover(p){
    // Send state
    for(let i = 0; i < get(ui).connections.length; i++){
        get(ui).connections[i].c.send({
            type: 'handover',
            p,
            state: get(state)
        });
    }
}

export async function offerEffect(reactingP, generatingP, reactionCard, effect, attack){
    reactingP = getPlayerIndex(reactingP);
    generatingP = getPlayerIndex(generatingP);
    reactionCard = reactionCard.uniqueID;

    let alreadySent = false;
    
    // fresh: sendUpdate() empties state.pastMessages on every full-state send, so
    // the local copy cannot answer "have I already made this offer?".
    let past = await pastMessages('current_games', get(state).gameID, true);
    let data = await currentMessage('current_games', get(state).gameID, true);
    if(data) past = [data, ...past];

    let code = get(state).offerCounter;

    state.update(s => {
        s.offerCounter++;
        return s;
    })

    past = past.find(m => m.offerNum == code)//get(state).offerCounter);
    if(past){
        
        if(past.type == 'effect_response'){
            if(data && data.offerNum == code /*get(state).offerCounter*/){
                // It's current, so it will be dealt with presently
                alreadySent = true;
                 console.log('[db] Effect response already sent, so waiting', get(state).offerCounter)
            }else{
                // This has already been completed
                state.update(s => {
                    s.activePlayer = past.generatingP;
                    return s;
                })
                res.update(r => {
                    r.savedState = clone(get(state));
                    return r;
                })
                let response = past.response;
                response.p = get(state).players[response.p];
                // If this is the _current_ message, move it along

                return response; // All done
            }
            
        }else if(past.type == 'effect_offer'){
            // already made offer, so wait until you get response
            alreadySent = true;
            console.log('[db] Effect offer already sent, so waiting', get(state).offerCounter)
        }
    }
    
    if(!alreadySent){
        let e = clone(effect);
        if(e.text){
            // improve the below in time
            e.text = e.text.replaceAll('Your opponent', 'You');
            e.text = e.text.replaceAll('your opponent', 'you');
            e.text = e.text.replaceAll('Their', 'Your');
            e.text = e.text.replaceAll('their', 'your');
            e.text = e.text.replaceAll('They', 'You');
            e.text = e.text.replaceAll('they', 'you');
        }
        state.update(s => {
            s.offerCounter++; // Before sending the message so that subsequent ones continue to update
            s.activePlayer = generatingP; // added Jan 2026 so that the message always sends... see if it helps
            return s;
        })

        await sendMessage('current_games', get(state).gameID, {
            type: 'effect_offer',
            reactingP,
            generatingP,
            reactionCard,
            effect: e,
            attack,
            frame: frameFor(effect), // so "it" in the effect binds as it would here
            offerNum: code//get(state).offerCounter
            //state: get(state)
        });
    }
    
    state.update(s => {
        s.activePlayer = reactingP;
        return s;
    })

    return new Promise((resolve, reject) => {
        
        ui.update(ui => {
            ui.reactionFunc = [(arg) => {
                state.update(s => {
                    s.activePlayer = generatingP;
                    //s.offerCounter++;
                    return s;
                })
                console.log('offer completed', get(state));
                resolve(arg);
                /*tick().then(() => {
                    resolve(arg);
                });*/
            }, ...ui.reactionFunc];
            return ui;
        })
    });

    /*

    for(let i = 0; i < get(ui).connections.length; i++){
        get(ui).connections[i].c.send({
            type: 'effect_offer',
            reactingP,
            generatingP,
            reactionCard,
            effect,
            attack,
            state: get(state)
        });
        return new Promise((resolve, reject) => {
            state.update(s => {
                s.activePlayer = reactingP;
                return s;
            })
            ui.update(ui => {
                ui.reactionFunc = (arg) => {
                    state.update(s => {
                        s.activePlayer = generatingP;
                        return s;
                    })
                    return resolve(arg);
                }
                return ui;
            })
        })
    }*/
}

export async function launchReaction(reactingP, generatingP, reactionCard, effect, type, attack, params, manAuto = 'auto'){
    reactingP = getPlayerIndex(reactingP);
    generatingP = getPlayerIndex(generatingP);
    reactionCard = reactionCard.uniqueID;

    let alreadySent = false;

    let past = await pastMessages('current_games', get(state).gameID, true);
    let data = await currentMessage('current_games', get(state).gameID, true);
    if(data) past = [data, ...past];

    past = past.find(m => m.offerNum == get(state).offerCounter);
    if(past){
        if(past.type == 'reaction_response'){
            if(data && data.offerNum == get(state).offerCounter){
                // It's current, so it will be dealt with presently
                alreadySent = true;
                console.log('[db] Reaction response already sent, so waiting', get(state).offerCounter)
            }else{
                // This has already been completed
                state.update(s => {
                    s.activePlayer = past.generatingP;
                    return s;
                })
                res.update(r => {
                    r.savedState = clone(get(state));
                    return r;
                })
                let response = past.response;
                response.p = get(state).players[response.p];
                // If this is the _current_ message, move it along

                return response; // All done
            }
            // (there used to be a second `return response` here, outside the block
            //  that declares it — a hard ReferenceError on exactly the resume path
            //  this branch exists to handle)
        }else if(past.type == 'reaction_offer'){
            // already made offer, so wait until you get response
            alreadySent = true;
            console.log('[db] Reaction offer already sent, so waiting')
        }
    }
    
    if(!alreadySent){
        await sendMessage('current_games', get(state).gameID, {
            type: 'reaction_offer',
            reactingP,
            generatingP,
            reactionCard,
            action: type,
            attack,
            effect,
            params,
            manAuto,
            offerNum: get(state).offerCounter
            //state: get(state)
        });
    }

    

    state.update(s => {
        s.activePlayer = reactingP;
        return s;
    })

    return new Promise((resolve, reject) => {
        
        ui.update(ui => {
            ui.reactionFunc = [(arg) => {
                state.update(s => {
                    s.activePlayer = generatingP;
                    s.offerCounter++;
                    return s;
                })
                console.log('launch reaction finished')
                return resolve(arg);
            }, ...ui.reactionFunc];
            return ui;
        })
    })

    /*

    //handover(reactingP); // So everything is in sync
    for(let i = 0; i < get(ui).connections.length; i++){
        get(ui).connections[i].c.send({
            type: 'reaction_offer',
            reactingP,
            generatingP,
            reactionCard,
            action: type,
            effect,
            params,
            manAuto,
            state: get(state)
        });
    }*/
    
}

export function offerAction(reactingP, generatingP, reactionCard, action, params){
    reactingP = getPlayerIndex(reactingP);
    generatingP = getPlayerIndex(generatingP);
    reactionCard = reactionCard.uniqueID;
    for(let i = 0; i < get(ui).connections.length; i++){
        get(ui).connections[i].c.send({
            type: 'action_offer',
            reactingP,
            generatingP,
            reactionCard,
            action,
            params,
            state: get(state)
        });
    }
    return new Promise((resolve, reject) => {
        state.update(s => {
            s.activePlayer = reactingP;
            return s;
        })
        ui.update(ui => {
            ui.reactionFunc = [(arg) => {
                state.update(s => {
                    s.activePlayer = generatingP;
                    return s;
                })
                return resolve(arg);
            }, ...ui.reactionFunc];
            return ui;
        })
    })
}

export function sendAlert(message){
    if(get(ui).connections.length == 0) return; // No need to pass on unless networked
    console.log('sending message', message)
    for(let conn of get(ui).connections){ // Just send round robin
        conn.c.send({ 
            type: 'alert',
            message
        });
    }
}

export function pauseUpdates(){
   // return;
    ui.update(ui => {
        ui.pauseUpdates = true;
        return ui;
    })
}

export function unPauseUpdates(){
    //return;
    ui.update(ui => {
        ui.pauseUpdates = false;
        return ui;
    })
    //sendUpdate(); // To catch up – except no need because it's always updating soon after...
}

// Undo history — prevStates, undos, deltas — is a local concern. The other player
// cannot use it, and it is by far the largest thing in this bundle: prevStates
// grows by a full state clone per action, so this used to reach several megabytes
// per step and was serialised and deflated on the main thread every time.
function extractRelevantPartsOfRes(){
    let {
        initialState,
        interimState,
        nextDelta,
        savedState,
        undoThreshold,
        continuationCheckpoint
    } = get(res);
    return {
        initialState,
        interimState,
        nextDelta,
        savedState,
        undoThreshold,
        continuationCheckpoint
    }
}

export function isNetworkGame(){
    if(!get(state).gameShared) return false;
    if(!get(state).players.some(p => p.username != get(state).hostUsername)) return false;
    return true;
}

export function sendUpdate(force = false, withRes = false, rightNow = false){
    //dbUpdateGame()
    /*if(!get(ui).synced){
        console.log('Not synced so not updating yet');
        return;
    }*/
   if(!get(state).gameShared) return;
   if(get(ui).pauseUpdates) return;
   if(get(ui).observer) return; // Never update as observer
   if(!force && !isMe(get(state).activePlayer)) return; // Don't send unless you're active
    if(force || get(ui).canSave && !Array.isArray(get(state).workingLog) && !get(ui).catchingUp){
        resetContinuationBaseline('sendUpdate');
        state.update(s => {
            s.pastMessages = []; // Could reinstate?
            return s;
        })
        //let toUpdate = clone(get(state));
        // Removing debouncing for now for maximal responsiveness but could reintroduce if need be
        //dbUpdateGame(get(state), [], get(ui), force ? 'force' : 'all'); // So always synced
        console.log('[db] updating full state', clone(get(state)));
        //console.trace();
        let extras = false;
        if(withRes){
            extras = {
                res: extractRelevantPartsOfRes()
            }
        }
        dbUpdateGame(get(state), [], get(ui), force ? 'force' : 'all', extras, rightNow);
        //sendQueue.add(async () => await updateGame(get(state), [], get(ui), force ? 'force' : 'all'), extras);
    }else{
        //let toUpdate = clone(get(state));
        console.log('[db] updating changelist', clone(get(state)))
        //console.trace();
        dbUpdateGame(get(state), get(state).choices.thisTurn, get(ui), ['changelist', 'changediffs_compressed'], false, rightNow);
        //sendQueue.add(async () => await updateGame(get(state), get(state).choices.thisTurn, get(ui), ['changelist', 'changediffs_compressed']));
    }
}


// Resolved by whichever client answers; assigning it without declaring it threw
// in strict mode, which is where every module in this app runs.
let playerResponse = false;

export async function askOtherPlayer(p, message, options = false, extras={}){
    if(isMe(p)){
        // Handle via a pause/choose
        await changeSeat(p);
        if(!options){
            await pause(message, extras);
            return true;
        }else if(options.some(o => typeof o === 'object')){
            // Cards
            return await chooseCards(message, options, extras);
        }else{
            return await choose(message, options, extras);
        }
    }


    state.update(s => {
        s.activePlayer = p;
        s.playerMessage = message;
        return s;
    });

    return new Promise((resolve, reject) => {
        playerResponse = (arg) => {
            return resolve(arg);
        }
    })
}

export function fbInit(){
    return fireBaseInitialised;
}

export async function initialiseFirebase(){
    if(fireBaseInitialised) return true;
    if(!window.navigator.onLine) return false;
    const firebaseConfig = {
        apiKey: "AIzaSyCysbC7CEIci1VLjCFJwWNrLqZx53eMmHM",
        authDomain: "stimperium-260b7.firebaseapp.com",
        projectId: "stimperium-260b7",
        storageBucket: "stimperium-260b7.appspot.com",
        databaseURL: 'https://stimperium-260b7-default-rtdb.europe-west1.firebasedatabase.app/',
        messagingSenderId: "509165597934",
        appId: "1:509165597934:web:5e0d441f073afd5714efff"
      };

      /*if (getApps().length < 1) {
        initializeApp(firebaseConfig);
        // Initialize other firebase products here
      }else{
        
      }*/


    try{
        !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
        
        firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                //let idToken = await user.getIdToken();
                uid = user.uid;
                console.log('uid', uid);
                // Game keys and the admin check are built on this uid. Keep a copy that
                // survives Firebase Auth being removed (Release C of the PocketBase move).
                idbGet('deviceId').then(d => { if(!d) return idbSet('deviceId', uid); }).catch(e => console.log('Unable to store deviceId', e));
                let a = isAuthorised();
                if(a){
                    ui.update(ui => {
                        ui.unlocked = true;
                        return ui;
                    });
                    username = a;
                }
                let u = new URLSearchParams();
                u.set('uid', uid);
                u.set('stats', true);
                uidURL = '?'+u.toString();

                // ...
            } else {
                // User is signed out
                // ...
            }
        });

        await firebase.auth().signInAnonymously();
        db = firebase.firestore();
        console.log(db);

        let qs = await db.collection('usernames').get();
        usernames = [];
        
        qs.forEach((doc) => {
            usernames = [...usernames, {
                uid: doc.id,
                name: doc.data().name
            }];
        });
        let uuRef = db.collection('usernames').doc(uid);
        let doc = await uuRef.get();
        //console.log(uuRef)
        if(doc.exists){
            username = doc.data().name;
            prefs.update(p => {
                p.username = username;
                return p;
            })
            await idbSet('username', username);
            await idbSet('prefs', get(prefs));
        }
        db.collection('usernames').onSnapshot((qs) => {
            usernames = [];
            qs.forEach((doc) => {
                usernames = [...usernames, {
                    uid: doc.id,
                    name: doc.data().name
                }];
            });
        }, (error) => {
            console.log('Unable to listen for username changes: '+error.message);
        })

        fireBaseInitialised = true;
        return true;
    }catch(error){
        console.log('Unable to initialise Firebase: '+error.message);
        return false;
    }
}

export async function uploadCampaign(c){
    if(!c.key){
        let g = c.games;
        if(g.length > 0){
            c.key = g[0].key;
        }else{
            return false;
        }
    }
    try{
        c = cleanCampaign(c);
        await db.collection('campaigns').doc(c.key).set(c);
        clearStatsCache();
    }catch(e){
        alert('Unable to upload campaign:'+e.message);
        return false;
    }
    if(PB_WRITE){
        // The campaign is also kept on the device and re-sent after every game, so a
        // failure here is caught up next time rather than blocking.
        try{
            await pbWriteReady();
            await pbStats.uploadCampaign(c);
        }catch(e){
            console.log('Unable to upload campaign to PocketBase: '+e.message);
        }
    }
    return true;
}

function cleanCampaign(c){
    if(!c.games) return c;
    for(let g of c.games){
        if(g.reward && g.reward.effect){
            if(Array.isArray(g.reward.effect)){
                g.reward.effect = g.reward.effect.flat(3);
            }
        }
    }
    return c;
}

// Resolves true only when the game is safely stored, which is what lets
// uploadQueuedGames() (save.js) drop it from the device's queue. Anything less and the game
// stays queued and is retried; every write here is an idempotent upsert, so retries are safe.
//   PB_WRITE off: the Firestore game doc AND its full state / replay docs
//   PB_WRITE on:  PocketBase has the whole game (doc + blobs, confirmed by hash) AND the
//                 Firestore game doc exists, while the Stats tab can still read Firestore.
//                 A failed Firestore *blob* write doesn't block then: PocketBase has it,
//                 and a blob over Firestore's 1 MiB limit would otherwise never leave the queue.
// Previously a failed blob write still returned true, and the game's log was lost.
export async function addGame(game, key, options = {}){
    let quiet = options.quiet || false;
    let say = (msg) => quiet ? console.log(msg) : alert(msg);
    let firebaseReady = await initialiseFirebase();
    if(!firebaseReady && !PB_WRITE){
        if(!quiet) alert('Game saved locally; upload will be retried when Firebase is available.');
        return false;
    }

    // Both stores get exactly the same document, so migrate.mjs verify can compare them.
    let gameMain = {...game, uploadType: 'split'}; // remove uploadType to revert
    delete gameMain.fullState;
    delete gameMain.replayInfo;

    let pbDone = false;
    if(PB_WRITE){
        try{
            await pbWriteReady();
            pbDone = await pbStats.uploadGame({...gameMain, fullState: game.fullState, replayInfo: game.replayInfo}, key);
            clearStatsCache();
        }catch(e){
            console.log('Unable to upload game to PocketBase: '+(e && e.message), e);
        }
    }

    let fsMain = false;
    let fsBlobs = true;
    if(firebaseReady){
        try{
            await db.collection('games').doc(key).set(gameMain);
            fsMain = true;
            clearStatsCache(); // so the Stats tab picks the new game up
        }catch(e){
            console.log('Unable to upload game to Firestore: '+e.message);
        }
        if(fsMain){
            try{
                if(game.fullState) await db.collection('games_full').doc(key).set({fullState: game.fullState});
                if(game.replayInfo) await db.collection('games_replay').doc(key).set({replayInfo: game.replayInfo});
            }catch(e){
                fsBlobs = false;
                console.log('Unable to upload full log to Firestore: '+e.message);
            }
        }
    }

    let done = PB_WRITE ? (pbDone && fsMain) : (fsMain && fsBlobs);
    if(done){
        console.log('Uploaded game '+key);
        return true;
    }
    if(fsMain || pbDone){
        say('Uploaded game stats, but not all of it yet: the game is kept on this device and the rest will be retried.');
    }else{
        say('Unable to upload game; it is kept on this device and will be retried.');
    }
    return false;
}

// The whole archive is ~90MB over ~1400 games, and the Stats tab is rebuilt from
// scratch every time it is opened, so hold onto it. Cleared when a game or
// campaign is uploaded, and by the Refresh button on the Stats tab.
let gamesCache = false;
let campaignsCache = false;

export function clearStatsCache(){
    gamesCache = false;
    campaignsCache = false;
}

export async function downloadGames(force = false){
    if(gamesCache && !force) return gamesCache;
    if(statsSource() == 'pb'){
        try{
            gamesCache = await pbStats.downloadGames(force);
            return gamesCache;
        }catch(e){
            console.log('Unable to download games', e.message);
            return [];
        }
    }
    if(!await initialiseFirebase()) return [];

    let games = [];
    try{
       let qS = await db.collection('games').get();
       qS.forEach((doc) => {
        games = [...games, doc.data()];
       })
       gamesCache = games;
    }catch(e){
        console.log('Unable to download games', e.message);
    }
    return games;
}

export async function downloadIndividualGame(key){
    if(statsSource() == 'pb'){
        try{
            return [await pbStats.downloadGame(key)];
        }catch(e){
            console.log('Unable to download game', key, e.message);
            return [];
        }
    }
    if(!await initialiseFirebase()) return [];

    let games = [];
    try{
       let doc = await db.collection('games').doc(key).get();
       if(doc.exists){
        games.push(doc.data());
       }else{
        console.log('no such game apparently', key);
       }
    }catch(e){
        console.log('Unable to download games', e.message);
    }
    return games; 
}

export async function loadCampaigns(onlyOngoing = false){
    if(statsSource() == 'pb'){
        try{
            return await pbStats.loadCampaigns(get(prefs).username, onlyOngoing);
        }catch(e){
            console.log('Unable to download campaigns', e.message);
            return [];
        }
    }
    if(!await initialiseFirebase()) return [];
    let campaigns = [];
    try{
        let q = db.collection('campaigns').where("username", "==", get(prefs).username);
        if(onlyOngoing) q = q.where('ended', '==', false)
        let qS = await q.get();
        qS.forEach((doc) => {
         campaigns = [...campaigns, doc.data()];
        })
     }catch(e){
         console.log('Unable to download campaigns', e.message);
     }
     return campaigns;
}

export async function loadAllCampaigns(force = false){
    if(campaignsCache && !force) return campaignsCache;
    if(statsSource() == 'pb'){
        try{
            campaignsCache = await pbStats.loadAllCampaigns();
            return campaignsCache;
        }catch(e){
            console.log('Unable to download campaigns', e.message);
            return [];
        }
    }
    if(!await initialiseFirebase()) return [];
    let campaigns = [];
    try{
        let q = db.collection('campaigns');
        let qS = await q.get();
        qS.forEach((doc) => {
         campaigns = [...campaigns, doc.data()];
        })
        campaignsCache = campaigns;
     }catch(e){
         console.log('Unable to download campaigns', e.message);
     }
     return campaigns;
}

// Whether a game has a log/replay that loadFull() can fetch.
export function hasFullStateToLoad(g){
    return !!(g && (g.hasFullState || pbStats.hasBlobs(g)));
}

export async function loadFull(g){
    if(pbStats.hasBlobs(g)){
        try{
            return await pbStats.loadBlobs(g);
        }catch(e){
            alert('Unable to load full data:'+e.message);
            return false;
        }
    }
    if(!await initialiseFirebase()) return false;
    try{
        let doc;
        let extra;
        if(g.uploadType == 'split'){
            let fullState;
            let replayInfo;
            try{
                let ref = db.collection('games_full').doc(g.key);
                console.log(ref);
                fullState = await ref.get();
                fullState = fullState.data();
                console.log(fullState);
                fullState = fullState.fullState;
            }catch(e){
                console.log('Error loading full state: '+e);
            }
            try{
                let ref = db.collection('games_replay').doc(g.key);
                replayInfo = await ref.get();
                replayInfo = replayInfo.data().replayInfo;
            }catch(e){
                console.log('Error loading replay info: '+e);
            }
            extra = {
                fullState,
                replayInfo
            }
        }else{
            doc = await db.collection('games_extra').doc(g.key).get();
            extra = doc.data();
        }
        
        if(extra){
            g.fullState = extra.fullState;
            g.replayInfo = extra.replayInfo;
            return true;
        }else{
            throw 'no doc!'
        }
    }catch(e){
        alert('Unable to load full data:'+e);
    }
    return false;
}

export async function setUsername(username = false){
    while(!username || username.trim() == ''){
        username = prompt('Enter a publicly-visible username to associate with this device:', username ? username : '');
    }
    username = username.trim();
    console.log(username);
    let saveLocalUsername = async () => {
        prefs.update(p => {
            p.username = username;
            return p;
        });
        await idbSet('username', username);
        await idbSet('prefs', get(prefs));
        return username;
    };
    if(!window.navigator.onLine || !db || !uid){
        return saveLocalUsername();
    }
    if(PB_WRITE){
        pbWriteReady().then(() => pbStats.setUsername(uid, username)).catch(e => console.log('Unable to save username to PocketBase: '+e.message));
    }
    // Only displays once 
    try{
        await db.collection('usernames').doc(uid).set({
            name: username
        });
        return saveLocalUsername(); 
    }catch(error){
        console.log("Unable to alter username: "+error.message);
        return saveLocalUsername();
    }	
}


export async function unlock(pwd){
    if(await sha256(pwd) == get(ui).pwd_hash){
        ui.update(ui => {
            ui.unlocked = true;
            return ui;
        })
        return true;
    }else{
        alert('Password incorrect!');
        return false;
    }
}

/*export async function unlock(pwd){
    if(!window.navigator.onLine){
        if(await idbGet('unlocked')){
            ui.update(ui => {
                ui.unlocked = true;
                return ui;
            })
        }else{
            alert('Unable to unlock offline: go online first')
        }
        return;
    }
	await initialiseFirebase();
	let realPwd = await db.collection('protect').doc('password').get();
	if(pwd == realPwd.data().value){
		ui.update(ui => {
            ui.unlocked = true;
            return ui;
        })
        console.log('unlocked')
	}else{
		alert('Password incorrect!')
	}
}*/

/*
export async function setupMultiplayer(id = false){
    await initialiseFirebase();
    if(get(ui).peer && !get(ui).peer.destroyed) return; // Already done!
   
    let un = await getUsername();
    setupPeer(id, un);
}*/
